import { render, staticRenderFns } from "./DeleteNotice.vue?vue&type=template&id=5679de0a"
import script from "./DeleteNotice.vue?vue&type=script&lang=js"
export * from "./DeleteNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports